import { render, staticRenderFns } from "./delistedProducts.vue?vue&type=template&id=2513e5ba&scoped=true&"
import script from "./delistedProducts.vue?vue&type=script&lang=js&"
export * from "./delistedProducts.vue?vue&type=script&lang=js&"
import style0 from "./delistedProducts.vue?vue&type=style&index=0&id=2513e5ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2513e5ba",
  null
  
)

export default component.exports